/* Bron-filter chips (alle / manueel / AI agent / pipeline request). */
import React from "react";
import i18n from "i18next";

/* ------------------------------------------------------------------ */
/*  Source filter row                                                  */
/* ------------------------------------------------------------------ */
function SourceFilter({ counts, value, onChange }) {
    const items = [
        { id: "all",              label: i18n.t("pipeline_sales.src_all"), count: counts.all, accent: "var(--jr-text-2)" },
        { id: "manual",           label: i18n.t("pipeline_sales.src_manual"),     count: counts.manual, accent: "var(--jr-success)" },
        { id: "agent",            label: "AI Agent",     count: counts.agent, accent: "var(--jr-info)" },
        { id: "pipeline_request", label: "Pipeline request", count: counts.pipeline_request, accent: "#a855f7" },
    ];
    return (
        <div className="flex flex-wrap items-center gap-2" data-testid="source-filter">
            {items.map((it) => (
                <button key={it.id} onClick={() => onChange(it.id)} data-testid={`filter-source-${it.id}`}
                    className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs transition-colors border ${value === it.id ? "bg-white/[0.08] text-white border-white/15" : "border-white/8 text-[var(--jr-text-2)] hover:bg-white/5"}`}>
                    <span className="w-2 h-2 rounded-full" style={{ background: it.accent }} />
                    {it.label}
                    <span className="text-[10px] font-mono text-[var(--jr-text-3)]">{it.count}</span>
                </button>
            ))}
        </div>
    );
}

export default SourceFilter;
